var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 76,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    x: 20.5,
    y: 26.5,
    fill: "#FFEEE5",
    rx: 5.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    x: 20.5,
    y: 26.5,
    stroke: "#CC3D00",
    rx: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CC3D00",
    strokeLinecap: "round",
    d: "M30.5 33.5h12M30.5 37.5h12M30.5 41.5h12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.57aa4a1b6aaab3ade6ce3bc3a1177531.svg";
export { ForwardRef as ReactComponent };